var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[
    'gift-card-wrapper',
    'flex-col-center',
    _vm.awardNumberClass,
    _vm.displayLayout,
    _vm.cardType,
    _vm.hasBgColor ? 'hasBg' : 'noBg',
    _vm.fissionGame,
    _vm.showScore ? 'has-padding-top' : 'no-padding-top',
  ]},[_c('card-in-column',{attrs:{"type":_vm.type,"cardType":_vm.cardType,"dataSource":_vm.datas,"displayMode":_vm.displayMode},on:{"className":_vm.getClassName}}),_vm._v(" "),(_vm.showShareBtn)?_c('share-btn',{class:['share-btn-wrapper', _vm.fissionGame],attrs:{"btnText":_vm.$t('fission.share-one'),"tipsLeft":"50%","type":_vm.type,"tipsText":_vm.tipsText,"activityId":_vm.activityId,"firstShareStatus":_vm.firstShareStatus,"hasTips":""},on:{"click-share":_vm.clickShare}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }